import React, { Component } from 'react';
export default class Loader extends Component {
  render() {
    return <img src="/icons/Loader/Eclipse-1s-200px.svg" className="loader" alt={'loader'} />;
  }
}
